module Constants {
	export module CsChatConstants {
		export var VISIBILITY_MINIMIZED: string = "minimized";
		export var VISIBILITY_MAXIMIZED: string = "maximized";
		export var VISIBILITY_HIDDEN: string = "hidden";
		export var AGENTS_ONLINE: string = "online";
		export var AGENTS_OFFLINE: string = "offline";
		export var CUSTOMER_BROWSING: string = "browsing";
		export var CUSTOMER_INVITED: string = "invited";
		export var CUSTOMER_QUEUED: string = "queued";
		export var CUSTOMER_CHATTING: string = "chatting";
		export var PROVIDER_LIVECHAT: string = "livechat";
	}
	export module UserPanelConstants {
		export var ACTIVITY_FEED: string = "ActivityFeed";
		export var PATIENT_PANEL: string = "PatientPanel";
		export var PROGRESS_NOTE: string = "ProgressNote";
		export var SCHEDULER_FILTER_PANEL: string = "SchedulerFilterPanel";
		export var VERTICAL_WORKFLOW: string = "VerticalWorkflow";
		export var CALENDAR_TIMELINE_VIEW: string = "CalendarTimelineView";
		export var CALENDAR_EXPANDED_VIEW: string = "CalendarExpandedView";
		export var SCHEDULER_SHOW_UNAVAILABLE_PROVIDERS: string = "SchedulerShowUnavailableProviders";
	}
	export module BatchPrintConstants {
		export var UI_STATUS_FAILED: number = 0;
		export var UI_STATUS_PENDING: number = 1;
		export var UI_STATUS_PROCESSING: number = 2;
		export var UI_STATUS_READY: number = 3;
		export var PDF_STATUS_FAILED: number = 4;
		export var PDF_STATUS_READY: number = 3;
		export var PDF_STATUS_PROCESSING: number = 2;
		export var PDF_STATUS_PENDING: number = 1;
		export var PDF_STATUS_NEW: number = 0;
	}
	export module BergBalanceTestConstants {
		export var QUESTION1_ANSWER4: string = "Able to stand without using hands and stabilize independently";
		export var QUESTION1_ANSWER3: string = "Able to stand independently using hands";
		export var QUESTION1_ANSWER2: string = "Able to stand after using hands after several tries";
		export var QUESTION1_ANSWER1: string = "Needs minimal aid to stand 30 seconds unsupported";
		export var QUESTION1_ANSWER0: string = "Needs moderate or maximum assist to stand";
		export var QUESTION2_ANSWER4: string = "Able to stand safely 2 minutes";
		export var QUESTION2_ANSWER3: string = "Able to stand 2 minutes with supervision";
		export var QUESTION2_ANSWER2: string = "Able to stand 30 seconds unsupported";
		export var QUESTION2_ANSWER1: string = "Needs several tries to stand 30 seconds unsupported";
		export var QUESTION2_ANSWER0: string = "Unable to stand 30 seconds unsupported";
		export var QUESTION3_ANSWER4: string = "Able to sit safely and securely for 2 minutes";
		export var QUESTION3_ANSWER3: string = "Able to sit 2 minutes under supervision";
		export var QUESTION3_ANSWER2: string = "Able to sit 30 seconds";
		export var QUESTION3_ANSWER1: string = "Able to sit 10 seconds";
		export var QUESTION3_ANSWER0: string = "Unable to sit without support 10 seconds";
		export var QUESTION4_ANSWER4: string = "Sits safely with minimal use of hands";
		export var QUESTION4_ANSWER3: string = "Controls descent by using hands";
		export var QUESTION4_ANSWER2: string = "Uses back of legs against chair to control descent";
		export var QUESTION4_ANSWER1: string = "Sits independently but has uncontrolled descent";
		export var QUESTION4_ANSWER0: string = "Needs assistance to sit";
		export var QUESTION5_ANSWER4: string = "Able to transfer with minor use of hands";
		export var QUESTION5_ANSWER3: string = "Able to transfer safely definite need of hands";
		export var QUESTION5_ANSWER2: string = "Able to transfer with verbal cueing and/or supervision";
		export var QUESTION5_ANSWER1: string = "Needs one person to assist";
		export var QUESTION5_ANSWER0: string = "Needs 2 people to assist or supervise to be safe";
		export var QUESTION6_ANSWER4: string = "Able to stand 10 seconds safely";
		export var QUESTION6_ANSWER3: string = "Able to stand 10 seconds with supervision";
		export var QUESTION6_ANSWER2: string = "Able to stand 3 seconds";
		export var QUESTION6_ANSWER1: string = "Unable to keep eyes closed 3 seconds but stays steady";
		export var QUESTION6_ANSWER0: string = "Needs help to keep from falling";
		export var QUESTION7_ANSWER4: string = "Able to place feet together independently and stand 1 minute safely";
		export var QUESTION7_ANSWER3: string = "Able to place feet together independently and stand 1 minute with supervision";
		export var QUESTION7_ANSWER2: string = "Able to place feet together independently and hold for 30 seconds";
		export var QUESTION7_ANSWER1: string = "Needs help to attain position but able to stand 15 seconds feet together";
		export var QUESTION7_ANSWER0: string = "Needs help to attain position and unable to hold for 15 seconds";
		export var QUESTION8_ANSWER4: string = "Can reach forward confidently > 25 cm (10 in)";
		export var QUESTION8_ANSWER3: string = "Can reach forward 12.5 cm safely (5 in)";
		export var QUESTION8_ANSWER2: string = "Can reach forward >5 cm safely (2 in)";
		export var QUESTION8_ANSWER1: string = "Reaches forward but needs supervision";
		export var QUESTION8_ANSWER0: string = "Loses balance while trying/requires external support";
		export var QUESTION9_ANSWER4: string = "Able to pick up slipper safely and easily";
		export var QUESTION9_ANSWER3: string = "Able to pick up slipper but needs supervision";
		export var QUESTION9_ANSWER2: string = "Unable to pick up but reaches 2-5 cm (1-2 inches) from slipper and keeps balance independently";
		export var QUESTION9_ANSWER1: string = "Unable to pick up and needs supervision while trying";
		export var QUESTION9_ANSWER0: string = "Unable to try/needs assist to keep from losing balance or falling";
		export var QUESTION10_ANSWER4: string = "Looks behind from both sides and weight shifts well";
		export var QUESTION10_ANSWER3: string = "Looks behind one side only, other side shows less weight shift";
		export var QUESTION10_ANSWER2: string = "Turns sideways only but maintains balance";
		export var QUESTION10_ANSWER1: string = "Needs supervision when turning";
		export var QUESTION10_ANSWER0: string = "Needs assist to keep from losing balance or falling";
		export var QUESTION11_ANSWER4: string = "Able to turn 360 degrees safely in 4 seconds or less";
		export var QUESTION11_ANSWER3: string = "Able to turn 360 degrees safely one side only in 4 seconds or less";
		export var QUESTION11_ANSWER2: string = "Able to turn 360 degrees safely but slowly";
		export var QUESTION11_ANSWER1: string = "Needs close supervision or verbal cueing";
		export var QUESTION11_ANSWER0: string = "Needs assistance while turning";
		export var QUESTION12_ANSWER4: string = "Able to stand independently and safely and complete 8 steps in 20 seconds";
		export var QUESTION12_ANSWER3: string = "Able to stand independently and complete 8 steps > 20 seconds";
		export var QUESTION12_ANSWER2: string = "Able to complete 4 steps without aid, with supervision";
		export var QUESTION12_ANSWER1: string = "Able to complete > 2 steps, needs minimal assist";
		export var QUESTION12_ANSWER0: string = "Needs assistance from falling/unstable to try";
		export var QUESTION13_ANSWER4: string = "Able to place foot tandem independently and hold 30 seconds";
		export var QUESTION13_ANSWER3: string = "Able to place foot ahead of other independently and hold 30 seconds";
		export var QUESTION13_ANSWER2: string = "Able to take a small step independently and hold 30 seconds";
		export var QUESTION13_ANSWER1: string = "Needs help to step but can hold for 15 seconds";
		export var QUESTION13_ANSWER0: string = "Loses balance while stepping or standing";
		export var QUESTION14_ANSWER4: string = "Able to lift leg independently and hold > 10 seconds";
		export var QUESTION14_ANSWER3: string = "Able to lift leg independently and hold 5-10 seconds";
		export var QUESTION14_ANSWER2: string = "Able to lift leg independently and hold = or > 3 seconds";
		export var QUESTION14_ANSWER1: string = "Tries to lift leg unable to hold 3 seconds but remains standing independently";
		export var QUESTION14_ANSWER0: string = "Unable to try or needs assist to prevent fall";
	}
	export module CodeTableConstants {
		export var ADMISSION_STATUS: string = "AdmissionStatus";
		export var COMPONENT_OF_CARE: string = "ComponentOfCare";
		export var NON_WOUND_DIAGNOSIS: string = "NonWoundDiagnosis";
		export var SOFT_TISSUE_RADIONECROSIS: string = "SoftTissueRadionecrosis";
		export var SYSTEMATIC_INFLAMMATORY_DISEASE: string = "SystematicInflammatoryDisease";
		export var REFERRAL: string = "referral";
		export var YES_NO: string = "YesNo";
		export var PHONE_NUMBER_TYPE: string = "PhoneNumberType";
		export var STATES: string = "States";
		export var PRIMARY_PAYER: string = "PrimaryPayer";
		export var CAREGIVER: string = "Caregiver";
		export var UNIT_ACQUIRED: string = "UnitAcquired";
		export var AUTHORIZATION_REASON: string = "AuthorizationReason";
		export var VISIT_TYPE: string = "VisitType";
		export var ROOMS: string = "Rooms";
		export var REASON_CANCELLED: string = "ReasonCancelled";
		export var VISIT_CANCELLED_PLAN: string = "VisitCancelledPlan";
		export var COLLECTION_METHOD: string = "CollectionMethod";
		export var COLLECTION_LOCATION: string = "CollectionLocation";
		export var HOMEOSTASIS: string = "HomeostasisAchieved";
		export var CPT4_MODIFIERS: string = "CPT4Modifiers";
		export var PATIENT_STATUS: string = "PatientStatus";
		export var MASTER_INSURANCES: string = "MasterInsurances";
		export var REDOC_BILLINGDOCUMENT_MODIFIERS: string = "ReDocBillingDocumentModifiers";
		export var LYMPHEDEMA_LOCATION: string = "LymphedemaLocation";
		export var TEMP: string = "Temp";
		export var INFECTION: string = "Infection";
		export var PULSE: string = "Pulse";
		export var MSP_TYPE_CODE: string = "MspTypeCode";
		export var ETIOLOGY: string = "Etiology";
	}
	export module CommunicationTrackerConstants {
		export var TYPE_PLAN_OF_CARE: string = "Plan of Care";
		export var TYPE_PLAN_OF_CARE_ID: string = "5";
		export var TYPE_INITIAL_EVALUATION_PLAN_OF_CARE: string = "Initial Evaluation Plan of Care";
		export var TYPE_INITIAL_EVALUATION_PLAN_OF_CARE_ID: string = "6";
		export var TYPE_RE_EVALUATION_PLAN_OF_CARE: string = "Re-Evaluation Plan of Care";
		export var TYPE_RE_EVALUATION_PLAN_OF_CARE_ID: string = "7";
		export var TYPE_PHYSICIAN_COMMUNICATION: string = "Physician’s Communication";
		export var TYPE_PHYSICIAN_COMMUNICATION_ID: string = "1";
		export var TYPE_PHYSICIAN_ORDERS: string = "Physician’s Orders";
		export var TYPE_PHYSICIAN_ORDERS_ID: string = "2";
		export var TYPE_REFERRAL: string = "Referrals";
		export var TYPE_REFERRAL_ID: string = "3";
		export var TYPE_OTHER: string = "Other";
		export var TYPE_OTHER_ID: string = "4";
		export var METHOD_TEXT_E_FAX: string = "E-Fax";
		export var METHOD_ID_E_FAX: number = 2;
		export var METHOD_TEXT_MANUAL: string = "Manual";
		export var METHOD_ID_MANUAL: number = 7;
		export var RECIPIENT_CLINICIAN: string = "Clinician";
		export var RECIPIENT_PHYSICIANREFERRING: string = "PhysicianReferring";
		export var DIRECTION_INBOUND: string = "Inbound";
		export var DIRECTION_INBOUND_ID: string = "0";
		export var DIRECTION_OUTBOUND: string = "Outbound";
		export var DIRECTION_OUTBOUND_ID: string = "1";
		export var OTHER_VALUE: string = "-1";
	}
	export module FaxConstants {
		export var FAXCONTENT_PREFIX_PATIENTREPORT: string = "PatientReport~";
		export var FAXCONTENT_PREFIX_DOCUMENTVIEWER: string = "DocumentViewer~";
		export var FAXCONTENT_PREFIX_CUSTOMSCANS: string = "CustomScans~";
		export var FAXCONTENT_GROUPNAME_PATIENTREPORTS: string = "Patient Reports";
		export var FAXCONTENT_GROUPNAME_INDIVIDUALDOCS: string = "Individual Documents";
		export var FAXCONTENT_GROUPNAME_MULTIDOCS: string = "Patient Documents and MultiDocs";
		export var FAXCONTENT_GROUPNAME_CLINICALREPORTS: string = "Clinical Reports";
		export var FAXCONTENT_GROUPNAME_CUSTOMSCANS: string = "Custom Scans";
	}
	export module InheritSettingsConstants {
		export var WOUNDCARE_SUPERBILL: string = "WoundCare.SuperBill";
	}
	export module ManagementBoardConstants {
		export var FILTER_STATUS_EVAL: string = "Evaluation";
		export var FILTER_STATUS_TX: string = "Treatment";
		export var FILTER_TYPE_STATUS: string = "Status";
		export var FILTER_TYPE_LAST_TX: string = "Last Tx";
		export var FILTER_TYPE_UNIT: string = "Unit";
		export var FILTER_TYPE_TRIAGE: string = "Triage";
		export var FILTER_TYPE_TX_REASON: string = "Tx Reason";
		export var FILTER_TYPE_PHYSICIAN: string = "Physician";
		export var LAST_TX_LT24: number = 0;
		export var LAST_TX_1D: number = 1;
		export var LAST_TX_2D: number = 2;
		export var LAST_TX_3D: number = 3;
		export var LAST_TX_4TO7D: number = 4;
		export var LAST_TX_GT7D: number = 5;
	}
	export module PatientDemographicsConstants {
		export var FirstName: string = "FirstName";
		export var LastName: string = "LastName";
		export var MiddleName: string = "MiddleName";
		export var Suffix: string = "Suffix";
		export var PreviousFirstName: string = "PreviousFirstName";
		export var PreviousLastName: string = "PreviousLastName";
		export var PreviousMiddleName: string = "PreviousMiddleName";
		export var DateOfBirth: string = "DateOfBirth";
		export var SexAtBirth: string = "SexAtBirth";
		export var GenderIndentification: string = "GenderIndentification";
		export var GenderIndentificationOther: string = "GenderIndentificationOther";
		export var EthnicityCodesText: string = "EthnicityCodesText";
		export var SecondaryEthnicityCodesText: string = "SecondaryEthnicityCodesText";
		export var RaceCodesText: string = "RaceCodesText";
		export var SecondaryRaceCodesText: string = "SecondaryRaceCodesText";
		export var SexualOrientation: string = "SexualOrientation";
		export var SexualOrientationOther: string = "SexualOrientationOther";
		export var AddressLine1: string = "AddressLine1";
		export var AddressLine2: string = "AddressLine2";
		export var City: string = "City";
		export var State: string = "State";
		export var ZipCode: string = "ZipCode";
		export var PreviousAddressLine1: string = "PreviousAddressLine1";
		export var PreviousAddressLine2: string = "PreviousAddressLine2";
		export var PreviousCity: string = "PreviousCity";
		export var PreviousState: string = "PreviousState";
		export var PreviousZipCode: string = "PreviousZipCode";
		export var PatientPhoneFormatted: string = "PatientPhoneFormatted";
		export var PatientSecondaryPhoneFormatted: string = "PatientSecondaryPhoneFormatted";
		export var EmailAddress: string = "EmailAddress";
		export var EmergencyContactFirstName: string = "EmergencyContactFirstName";
		export var EmergencyContactLastName: string = "EmergencyContactLastName";
		export var EmergencyContactRelationship: string = "EmergencyContactRelationship";
		export var IsPatientGuardian: string = "IsPatientGuardian";
		export var IsPatientGuardianAdLitem: string = "IsPatientGuardianAdLitem";
		export var EmergencyContactPhoneNumber: string = "EmergencyContactPhoneNumber";
		export var EmergencyContactAddress1: string = "EmergencyContactAddress1";
		export var EmergencyContactAddress2: string = "EmergencyContactAddress2";
		export var EmergencyContactCity: string = "EmergencyContactCity";
		export var EmergencyContactState: string = "EmergencyContactState";
		export var EmergencyContactZip: string = "EmergencyContactZip";
	}
	export module ExerciseProtocolConstants {
		export var USER_SCOPE_PREFIX: string = "U - ";
		export var LOCATION_SCOPE_PREFIX: string = "L - ";
		export var FACILITY_SCOPE_PREFIX: string = "F - ";
	}
	export module UserRoleConstants {
		export var COMPONENT_OF_CARE_USER: string = "ComponentOfCareUser";
		export var ELIGIBILITY_VERIFICATION_USER: string = "EligibilityVerificationUser";
	}
	export module VisitConstants {
		export var DISCIPLINE_PT: string = "PT";
		export var DISCIPLINE_OT: string = "OT";
		export var DISCIPLINE_SLP: string = "SLP";
		export var UnregisteredPatientIdEncrypted: string = "T0hX8uIyyf0%3d";
	}
	export module SchedulerConstants {
		export var DEFAULT_EVENT_BACKGROUND_COLOR: string = "#1e5d7d";
		export var DEFAULT_EVENT_FONT_COLOR: string = "#ffffff";
		export var DEFAULT_MAX_PROVIDERS_BEFORE_WARNING: number = 3;
		export var DEFAULT_LOW_THRESHOLD_COLOR: string = "#43ac6a";
		export var DEFAULT_MIDDLE_THRESHOLD_COLOR: string = "#f08a24";
		export var DEFAULT_HIGH_THRESHOLD_COLOR: string = "#f04124";
		export var DEFAULT_TIME_INCREMENT: number = 15;
		export var DEFAULT_MIN_TIME: string = "00:00";
		export var DEFAULT_MAX_TIME: string = "24:00";
		export var DEFAULT_OFFICE_START: string = "00:00";
		export var DEFAULT_OFFICE_END: string = "23:59";
		export var DEFAULT_OFFICE_BUSINESS_START: string = "08:00";
		export var DEFAULT_OFFICE_BUSINESS_END: string = "19:00";
		export var DEFAULT_VISIT_DURATION: number = 30;
		export var PRIMARY_CLINICIAN: string = "Primary";
		export var ANCILLARY_CLINICIAN: string = "Ancillary";
		export var SECONDARY_CLINICIAN: string = "Secondary";
		export var ASSISTANT_CLINICIAN: string = "Assistant";
	}
	export module WorkflowEditors {
		export var Procedures: string = "Procedures";
		export var TreatmentNotes: string = "Treatment Notes";
		export var TreatmentNotesEditor: string = "TreatmentNotes";
		export var ActiveWounds: string = "Active Wounds";
		export var ActiveWoundsEditor: string = "Wounds";
		export var InactiveWounds: string = "Inactive Wounds";
		export var InactiveWoundsEditor: string = "InactiveWounds";
		export var Medications: string = "Medications";
		export var VisitInfo: string = "Visit Info";
		export var Prescriptions: string = "Prescriptions";
		export var CellAndTissue: string = "SkinGraftModule";
		export var NPWT: string = "KCI";
		export var CompressionModule: string = "CompressionModule";
		export var WoundProductSupplier: string = "WoundProductSupplier";
		export var ClinicalStudies: string = "ClinicalStudies";
		export var Stomas: string = "Stomas";
		export var ChiefComplaintHPI: string = "Chief Complaint / HPI";
		export var VitalSignsPhysicalExam: string = "Vital Signs / Physical Exam";
		export var PatientHistoryAllergies: string = "Patient History / Allergies";
		export var Lymphedema: string = "Lymphedema";
		export var ArrivalAndHistory: string = "Arrival / History";
		export var NuoTherapeutics: string = "Nuo Therapeutics";
		export var SuperBill: string = "SuperBill";
		export var Billing: string = "Billing";
	}
	export module Roles {
		export var IPA_USER: string = "IPAUser";
		export var SCHEDULER_ADMIN: string = "SchedulerAdmin";
		export var THERAPIST: string = "Therapist";
		export var THERAPIST_INTERN: string = "TherapistIntern";
		export var THERAPIST_ASSISTANT: string = "TherapyAssistant";
		export var THERAPIST_ASSISTANT_INTERN: string = "TherapyAssistantIntern";
		export var FACILITY_ADMIN: string = "FacilityAdmin";
		export var READ_ONLY: string = "ReadOnly";
		export var BILLING_ADMIN: string = "BillingAdmin";
		export var BILLING_ACCESS: string = "BillingAccess";
		export var NETHEALTH_ADMIN: string = "NethealthAdmin";
		export var EFAX_USER: string = "eFaxUser";
		export var VIEW_SOCIAL_SECURITY_NUMBER: string = "ViewSocialSecurityNumber";
		export var PHYSICAN: string = "Physician";
		export var REFERRING_PHYSICIAN: string = "ReferringPhysician";
		export var PRIMARY_CARE_PHYSICIAN: string = "PrimaryCarePhysician";
		export var TRAVELING_PHYSICIAN: string = "TravellingPhysicianClient";
		export var CONNECTIONS_ADMIN: string = "ConnectionsAdmin";
		export var TALI_DICTATION: string = "TaliDictation";
		export var FINALIZE_VISIT_USER: string = "FinalizeVisitUser";
	}
	export module FacilitySettings {
		export var ACCOUNT_NUMBER: string = "AccountNumber";
		export var ALERTS: string = "Alerts";
		export var ARRIVAL_INFORMATION: string = "Arrivalinformation";
		export var USE_ENCOUNTER: string = "UseEncounter";
		export var HIDE_INSURANCE_DETAILS: string = "HideInsuranceDetails";
		export var HBO: string = "Hbo";
		export var TASKS: string = "Tasks";
		export var PATIENT_COMMUNICATION: string = "PatientCommunication";
		export var MEDICATIONS: string = "Medications";
		export var ADVANCED_INSURANCE: string = "AdvancedInsurance";
		export var PATIENT_ACTIVITY_SCANS: string = "CustomScans";
		export var DURABLE_MEDICAL_EQUIPMENT: string = "DurableMedicalEquipment";
		export var KCI_MODULE: string = "KCIModule";
		export var SKIN_SUBSTITUTE_MODULE: string = "SkinGraftModule";
		export var COMPRESSION_MODULE: string = "CompressionModule";
		export var FINALIZE_VISIT: string = "FinalizeVisit";
		export var FINALIZE_VISIT_PDF_INTERFACE: string = "FinalizeVisitPDFInterface";
		export var WOUND_CARE_PHYSICIAN: string = "WoundCarePhysician";
		export var REFERRING_PHYSICIAN: string = "ReferringPhysician";
		export var PRIMARY_CARE_PHYSICIAN: string = "PrimaryCarePhysician";
		export var ATTENDING_PHYSICIAN: string = "AttendingPhysician";
		export var AWP_INTERFACE_FACILITY: string = "AWPInterfaceFacility";
		export var DELETE_FUTURE_VISITS_UPON_DISCHARGE: string = "DeleteFutureVisitsUponDischarge";
		export var REDOC: string = "ReDoc";
		export var CARE_CENTER: string = "CareCenter";
		export var VISIT_TYPE: string = "VisitType";
		export var RCM: string = "RCM";
		export var PROCEDURES_SECTION: string = "ProceduresSection";
		export var DIRECT_EMAIL: string = "EnableDirectEmail";
		export var ESIGNATURE: string = "ESignature";
		export var ELECTRONIC_SIGNATURE_WARNING: string = "ElectronicSignatureWarning";
		export var ELECTRONIC_SIGNATURE_WARNING_DATE_RANGE: string = "ElectronicSignatureWarningDateRange";
		export var PROGRESSNOTES_MODULE: string = "PatientProgressNotes";
		export var TESTRESULTS_VISITACTION: string = "TestResultsVisitAction";
		export var WOUND: string = "Wound";
		export var ASSOCIATE_COMPONENT_OF_CARE_WITH_USER: string = "AssociateComponentOfCareWithUserProfile";
		export var ANCILLARY_STAFF: string = "AncillaryStaff";
		export var ANCILLARY_STAFF_DESCRIPTION: string = "AncillaryStaffDescription";
		export var COMPONENT_OF_CARE: string = "ComponentOfCare";
		export var COMPONENT_OF_CARE_LABEL: string = "ComponentOfCareLabel";
		export var CLINICIAN_DESCRIPTION: string = "ClinicianDescription";
		export var FILTERWORKSFLOWBYISITTYPE: string = "FilterWorkflowsByVisitType";
		export var REQUIRE_AUTHORIZATIONS_PER_PAYER_FOR_VISITS: string = "RequireAuthorizationsPerPayerForVisits";
		export var AUTHORIZATIONS_REMAINING_WARNING: string = "AuthorizationsRemainingWarning";
		export var AUTHORIZATIONS_REMAINING_WARNING_AMOUNT: string = "AuthorizationsRemainingWarningAmount";
		export var HIDE_VISIT_LENGTH: string = "HideVisitLength";
		export var RESTORIX_FACILITY: string = "RestorixFacility";
		export var WHITEBOARD: string = "Whiteboard";
		export var FOTO_INTEGRATION: string = "FotoIntegration";
		export var WORKFLOW_FOR_INITIAL_OR_SUBSEQUENT_VISIT: string = "WorkflowForInitialAndSubsequentVisit";
		export var AGILITY: string = "Agility";
		export var PROGRESS_NOTE_PANEL: string = "ProgressNotePanel";
		export var VISIT_CLASSIFICATION: string = "VisitClassification";
		export var IPA: string = "IPA";
		export var PRIMARY_PAYER: string = "PrimaryPayer";
		export var WTN_CLIENT: string = "WTNClient";
		export var ENABLE_INFORMATIONOBTAINEDFIELDS: string = "EnableInformationObtainedFields";
		export var PATIENT_ETHNICITY: string = "PatientEthnicity";
		export var PATIENT_RELIGION: string = "PatientReligion";
		export var AUTO_GENERATE_PATIENT_IDENTIFIERS: string = "AutoGeneratePatientIdentifiers";
		export var PEDIATRIC: string = "Pediatric";
		export var PHYSICAL_THERAPY_MODULE: string = "PhysicalTherapyModule";
		export var SECOND_CLINICIAN_DESCRIPTION: string = "SecondClinicianDescription";
		export var THIRD_PROVIDER_DESCRIPTION: string = "ThirdProviderDescription";
		export var USE_THIRD_PROVIDER: string = "ThirdProvider";
		export var USE_SECOND_CLINICIAN: string = "TwoClinicians";
		export var SUPERVISING_PHYSICIAN_ADDITIONAL_PHYSICIAN: string = "SupervisingAndAdditionalPhysician";
		export var MEDICARE_THERAPY_CAP_ALERT: string = "MedicareTherapyCapAlert";
		export var SCHEDULE_ASSISTANT: string = "ScheduleAssistant";
		export var PHYSICIAN_MODULE: string = "PhysicianModule";
		export var TIME_IN: string = "TimeIn";
		export var IPA_PHONIC_CHART: string = "IPAPhonicChart";
		export var STANDARDIZED_TESTS: string = "StandardizedTestsDocument";
		export var FILTERED_ACCESS_USERS: string = "FilteredAccessUsers";
		export var HIDE_CONSULT: string = "HideConsult";
		export var HIDE_PALLIATIVE: string = "HidePalliativeCare";
		export var CPT4_USER_FAVORITES: string = "CPT4UserFavorites";
		export var PATIENT_PORTAL: string = "PatientPortal";
		export var FAX_COMMUNICATION: string = "FaxCommunication";
		export var EXTERNAL_COMMUNICATION_TRACKING: string = "CommunicationsTracker";
		export var EXERCISE_PROTOCOLS: string = "ExerciseProtocols";
		export var EXERCISE_PRO_LIVE_INTEGRATION: string = "ExerciseProLiveIntegration";
		export var HOW_HEARD: string = "HowHeard";
		export var INQUIRY_DATE: string = "InquiryDate";
		export var NEW_TO_HOSPITAL: string = "NewToHospital";
		export var DO_NOT_SAVE_ON_NAVIGATE: string = "PCDoNotSaveOnNavigation";
		export var HIDE_START_VISIT: string = "HideStartVisit";
		export var AUTO_ASSIGN_WORKLIST: string = "AutoAssignWorklist";
		export var HIDE_PATIENT_CONTACT_INFORMATION: string = "HidePatientContactInformation";
		export var GENERAL_INFORMATION: string = "GeneralInformation";
		export var RISK_ASSESSMENT_PERFORMED: string = "RiskAssessmentPerformed";
		export var INPHONITE_INTERFACE: string = "InphoniteInterface";
		export var HABILITY_INTERFACE: string = "HabilityInterface";
		export var PATIENT_PHOTO: string = "Patientphoto";
		export var ADVANCED_DIRECTIVES: string = "AdvancedDirectives";
		export var IMMUNIZATIONS: string = "Immunizations";
		export var MISSING_PATIENT_INFO_ALERT: string = "MissingPatientInfoAlert";
		export var HIDE_DME_VENDOR_ON_OTHER_ORDERS: string = "HideDMEVendoronOtherOrders";
		export var VISIT_WORKLIST: string = "VisitWorklist";
		export var CASE_MANAGER: string = "CaseManager";
		export var PATIENT_CORP_NUM: string = "PatientCorporationNumber";
		export var DOCUMENT_LOCKING: string = "DocumentLocking";
		export var OSTOMY_MODULE: string = "OstomyModule";
		export var CIRCUMFERENTIAL_MEASUREMENT: string = "CircumferentialMeasurement";
		export var CAREGIVER_INFORMATION: string = "Caregiver";
		export var UNIT_ACQUIRED: string = "UnitAcquired";
		export var HOME_HEALTH_COMPANIES: string = "HomeHealthCompanies";
		export var TRANSPORTATION_AGENCY: string = "TransportationAgency";
		export var PHARMACY: string = "Pharmacy";
		export var USE_LOINC: string = "UseLOINC";
		export var TEST_PROCEDURES_DOCUMENT: string = "TestProceduresDocument";
		export var INTERFACE_ACCOUNT_NUMBERS: string = "InterfaceAccountNumbers";
		export var INHERIT_LAST_ACCOUNT_NUMBER: string = "InheritLastAccountNumber";
		export var AUTOMATIC_AUTHORIZATION_DEDUCTION: string = "AutomaticAuthorizationDeduction";
		export var READ_ONLY_ACCOUNT_NUMBER: string = "ReadOnlyAccountNumber";
		export var DIVERSIFIED_CLINICAL_SERVICES_CLIENT: string = "DiversifiedClinicalServicesClient";
		export var CALENDAR: string = "Calendar";
		export var PATIENT_WAIT_LIST: string = "PatientWaitList";
		export var MISSED_VISIT_REPORT: string = "MissedVisitReport";
		export var DISCHARGE_ON_FINALIZE_VISIT: string = "DischargeOnFinalizeVisit";
		export var SCHEDULE_AND_DISCHARGE_ON_FINALIZE_VISIT: string = "ScheduleAndDischargeFromFinalizeVisit";
		export var PRACTICE_EHR_RCM_INTEGRATION: string = "PracticeEhrRcmIntegration";
		export var VENDOR_WPS_CPN_CLINICIAN_RX_NET: string = "CPNClinicianRxNet";
		export var STATEMENT_BATCH_DESTINATION: string = "StatementBatchDestination";
		export var PROVIDER_SCHEDULES: string = "ProviderSchedules";
		export var BLOCK_SCHEDULING_FOR_UNAVAILABLE_PROVIDERS: string = "BlockSchedulingForUnavailableProviders";
		export var WORKLIST: string = "Worklist";
		export var MEDS_DRUG_DRUG: string = "MedsDrugDrug";
		export var MEDS_DRUG_ALLERGY: string = "MedsDrugAllergy";
		export var EPCS_ACTIVATION: string = "EPCSActivation";
		export var ARRIVAL_COGNITIVE_STATUS: string = "ArrivalCognitiveStatus";
		export var INPATIENT_CARE_SETTING: string = "InpatientCareSetting";
		export var USE_COC_ADDRESS_FOR_PATIENT_ADDRESS: string = "UseCoCAddressForPatientAddress";
		export var PDF_RESULTS_INTERFACE: string = "PDFResultsInterface";
		export var TREATMENT_CYCLE_CLINICIAN_DESCRIPTION: string = "TreatmentCycleClinicianDescription";
		export var FOTO_REPORTING_ENABLED: string = "FotoReportingEnabled";
		export var REDOC_MATCHON_DISCIPLINE: string = "RedocMatchOnDiscipline";
		export var DISABLE_INVALID_INTERVENTIONS_SUPERBILL: string = "DisableInvalidInterventionsSuperbill";
		export var MISSED_VISIT_PREDICTION: string = "MissedVisitPrediction";
		export var ENABLE_POPUP_SUPERBILL_ALERTS: string = "EnablePopupSuperbillAlerts";
		export var CHECK_PATIENT_ELIGIBILITY: string = "PatientEligibilityVerification";
		export var PATIENT_ELIGIBILITY_INCLUDE_PROVIDER_INFO: string = "PatientEligibilityIncludeProviderInfo";
		export var ACUTE_NON_DOCUMENTATION: string = "AcuteNonDocumentation";
		export var TISSUE_ANALYTICS_PATIENT_INTEGRATION: string = "TissueAnalyticsPatientIntegration";
		export var TISSUE_ANALYTICS_PROVIDER_INTEGRATION: string = "TissueAnalyticsProviderAppIntegration";
		export var TISSUE_ANALYTICS_SHOW_TISSUE_ANALYTICS_AREA: string = "ShowTissueAnalyticsArea";
		export var TISSUE_ANALYTICS_RETRACE_INTEGRATION: string = "TissueAnalyticsProviderRetraceIntegration";
		export var PATIENT_STATEMENT_SERVICES: string = "PatientStatementServices";
		export var TELEHEALTH_VISITS: string = "TelehealthVisits";
		export var PATIENT_ELIGIBILITY_PAYER_ID_MAPPING: string = "EligibilityPayerIdMapping";
		export var PAYER_RULES: string = "PayerRules";
		export var MANUAL_ORDER_ENTRY: string = "ManualOrderEntry";
		export var PATIENT_PARKING_LOT: string = "PatientParkingLot";
		export var HIDE_COMMONLY_USED_AND_MANUAL_PRODUCT_ENTRY: string = "HideCommonlyUsedAndManualProductEntry";
		export var REPUTATION_MANAGEMENT: string = "ReputationManagement";
		export var DUAL_DOCUMENTER: string = "DualDocumenter";
		export var PATIENT_PORTAL_APPOINTMENT_REQUEST: string = "PatientPortalAppointmentRequest";
		export var SHOW_TIMEZONE_ON_THERAPY_SUPERBILL: string = "ShowTimeZoneonTherapySuperbill";
		export var FOTO_PORTAL_INTEGRATION: string = "FotoPortalIntegration";
		export var PATIENT_MESSAGING: string = "PatientMessaging";
		export var PATIENT_MESSAGING_AUTO_ASSIGN: string = "PatientMessagingAutoAssign";
		export var PATIENT_MESSAGING_VISIT_REMINDERS: string = "PatientMessagingVisitReminders";
		export var CLIENT_SIDE_TIMEOUT: string = "ClientSideTimeout";
		export var PATIENT_PORTAL_DIGITAL_INTAKE: string = "PatientPortalDigitalIntake";
		export var AUTO_GENERATE_MRN_EXISTING_PATIENT: string = "AutoGenerateMrnExistingPatient";
		export var CLINICAL_SUMMARY: string = "ClinicalSummary";
		export var PCC_INTEGRATION: string = "PCCIntegration";
		export var PHYSICIAN_COMMUNICATION: string = "PhysicianCommunication";
		export var HIDE_SUPERBILL_MEDICARE_QUESTION: string = "HideMedicareParticipationQuestionOnSuperbill";
		export var SHOW_PCP_NAME_IN_PROGRESSNOTE: string = "ShowPCPNameInProgressNote";
		export var SHOW_VISIT_TYPE_IN_PROGRESSNOTE: string = "ShowVisitTypeInProgressNote";
		export var LONG_PLAN_OF_CARE: string = "LongPlanOfCare";
		export var CPT4_ADMIN_SUBSCRIBE_CODES_OPTION: string = "CPT4AdminSubscribeCodesOption";
		export var CLIA_NUM_PER_COC: string = "CliaNumPerCoc";
		export var SERVICE_TYPE: string = "ServiceType";
		export var MU_REPORTS: string = "MUReports";
		export var SimpleHTML: string = "SimpleHTML";
		export var SHOW_MEDICATIONS_AS_LIST_IN_PROGRESSNOTE: string = "ShowMedicationsAsListInProgressNote";
		export var PRINT_ALL_QUESTIONS: string = "PrintAllQuestions";
		export var CLINICAL_STUDIES: string = "ClinicalStudies";
		export var CLINICAL_STUDIES_AURIX: string = "ClinicalStudiesAurix";
		export var USE_MILLIMETERS: string = "Measurement";
		export var Enable_Facility_Data_Export: string = "EnableFacilityDataExport";
		export var REMOVE_ACCOUNT_NUMBER_HARD_STOP_NBI: string = "RemoveAccountNumberHardStopNbi";
		export var LESS_THAN_20_PERCENT_SLOUGH: string = "LessThan20PercentSlough";
		export var SEND_INTERFACE_MESSAGE_ON_VISIT_EVENT: string = "SendInterfaceMessageOnVisitEvent";
		export var LYMPHEDEMA_INTERVAL: string = "LymphedemaInterval";
		export var Multiple_Signatures: string = "MultipleSignatures";
		export var Show_Skin_Sub_Product_Size_Field: string = "ShowSkinSubProductSizeField";
		export var CONNECTIONS_MODULE: string = "ConnectionsModule";
		export var AUTO_UPDATE_ACCOUNT_NUMBER: string = "AutoUpdateAccountNumber";
		export var WOUNDEXPERT_BILLING_INTERFACE_CHARGE_TYPE: string = "WoundExpertBillingInterfaceChargeType";
		export var BILLING_INTERFACE_TRIGGER: string = "BillingInterfaceTrigger";
		export var PHYSICIAN_CPT4_CODES: string = "PhysicianCPT4Codes";
		export var TALI_DICTATION: string = "TaliDictation";
		export var ALWAYS_AUTOMATE_CCODES_SKIN_SUBSTITUTES: string = "AlwaysAutomateCCodesSkinSubstitutes";
		export var AUTO_GENERATE_CDA: string = "AutoGenerateCDA";
		export var FINALIZE_VISIT_CDA_INTERFACE: string = "FinalizeVisitCDAInterface";
		export var REQUIRE_TREATEMENT_CYCLE_INSURANCE_AUTH_EDITOR: string = "RequireTreatmentCycleInsuranceAuthEditor";
	}
	export module TimeSpan {
		export var TicksPerMillisecond: number = 10000;
		export var TicksPerSecond: number = 10000000;
		export var TicksPerMinute: number = 600000000;
		export var TicksPerHour: number = 36000000000;
		export var TicksPerDay: number = 864000000000;
	}
export module AccessTypes {
	export module Test {
		export var FACILITY_SETTING: string = "Test.FacilitySetting";
		export var ROLE: string = "Test.Role";
		export var BOTH: string = "Test.Both";
		export var NONE: string = "Test.None";
		export var REJECT: string = "Test.Reject";
		export var CALENDAR: string = "Test.Calendar";
	}
	export module User {
		export var CONTACT_INFORMATION_GET: string = "User.ContactInformation.Get";
		export var CONTACT_INFORMATION_PUT: string = "User.ContactInformation.Put";
		export var CONTACT_INFORMATION_DELETE: string = "User.ContactInformation.Delete";
		export var EM_AUTOMATION_GET: string = "User.EMAutomation.Get";
		export var EM_AUTOMATION_PUT: string = "User.EMAutomation.Put";
		export var ACTIVATE_PROVIDER_EPCS_GET: string = "User.ActivateProviderEPCS.Get";
		export var DEFAULT_PHYSICIAN_ORDERS_GET: string = "User.DefaultPhysicianOrders.Get";
		export var DEFAULT_PHYSICIAN_ORDERS_PUT: string = "User.DefaultPhysicianOrders.Put";
		export var WORKFLOW_CONFIGURATION_GET: string = "User.WorkflowConfiguration.Get";
		export var WORKFLOW_CONFIGURATION_POST: string = "User.WorkflowConfiguration.Post";
		export var CALENDAR_CONFIGURATION_GET: string = "User.CalendarConfiguration.Get";
		export var LEFT_PANEL_CONFIGURATION_GET: string = "User.LeftPanelConfiguration.Get";
		export var LEFT_PANEL_CONFIGURATION_PUT: string = "User.LeftPanelConfiguration.Put";
		export var CALENDAR_FILTER_CONFIGURATION_GET: string = "User.CalendarFilterConfiguration.Get";
		export var CALENDAR_FILTER_CONFIGURATION_PUT: string = "User.CalendarFilterConfiguration.Put";
		export var PHYSICAL_EXAM_TEMPLATE_GET: string = "User.PhysicalExamTemplate.Get";
		export var PHYSICAL_EXAM_QUICK_VIEW_GET: string = "User.PhysicalExamQuickView.Get";
		export var PROGRESS_NOTE_TEMPLATE_GET: string = "User.ProgressNoteTemplate.Get";
		export var ROS_QUICK_VIEW_ADMIN_GET: string = "User.ROSQuickViewAdmin.Get";
		export var FORMS_TO_BE_SIGNED_GET: string = "User.FormsToBeSigned.Get";
		export var TASK_LIST_GET: string = "User.TaskList.Get";
		export var QUICK_ACTIONS_MARKETING_LETTERS_GET: string = "User.QuickActions.MarketingLetters.Get";
		export var WHITEBOARD_GET: string = "User.Whiteboard.Get";
		export var EMERGENCY_ACCESS_GET: string = "User.EmergencyAccess.Get";
		export var IS_MANAGEMENT_ADMIN_USER_GET: string = "User.IsManagementAdminUser.Get";
		export var IS_MANAGEMENT_USER_GET: string = "User.IsManagementUser.Get";
		export var CPT4_FAVORITES: string = "User.Cpt4Favorites";
		export var EXERCISE_PROTOCOL_CONFIGURATION: string = "User.ExerciseProtocolConfiguration";
	}
	export module Navigation {
		export var FACILITY_ADMIN: string = "Navigation.FacilityAdmin";
		export var NHS_ADMIN: string = "Navigation.NHSAdmin";
		export var CALENDAR: string = "Navigation.Calendar";
		export var CACHE_ADMIN: string = "Navigation.CacheAdmin";
	}
	export module Patient {
		export var WORKFLOW_GET: string = "Patient.Workflow.Get";
		export var WORKFLOW_POST: string = "Patient.Workflow.Post";
		export var DASHBOARD_GET: string = "Patient.Dashboard.Get";
		export var GET: string = "Patient.Get";
		export var POST: string = "Patient.Post";
		export var DELETE: string = "Patient.Delete";
	}
	export module Scans {
		export var GET: string = "Patient.Scans.Get";
		export var POST: string = "Patient.Scans.Post";
		export var DELETE: string = "Patient.Scans.Delete";
	}
	export module Physician {
		export var GET: string = "Physician.Get";
		export var POST: string = "Physician.Post";
	}
	export module Clinician {
		export var GET: string = "Clinician.Get";
		export var POST: string = "Clinician.Post";
	}
	export module Insurance {
		export var GET: string = "Insurance.Get";
		export var POST: string = "Insurance.Post";
	}
	export module Admin {
		export var FACILITY_SETUP_GET: string = "Admin.FacilitySetup.Get";
		export var FACILITY_INFORMATION_GET: string = "Admin.FacilityInformation.Get";
	}
	export module FacilityAdmin {
		export var PATIENT_DASHBOARD_COPY_PUT: string = "FacilityAdmin.PatientDashboardCopy.Put";
		export var BIOEX_INTEGRATION_ADMIN: string = "FacilityAdmin.BioEx.Admin";
		export var FOTO_INTEGRATION_ADMIN: string = "FacilityAdmin.Foto.FotoAdmin";
	}
	export module SchedulerAdmin {
		export var PROVIDER_SCHEDULE_ADMIN: string = "SchedulerAdmin.ProviderSchedule.Admin";
	}
	export module Visit {
		export var POST: string = "Visit.Post";
		export var CREATE: string = "Visit.Create";
	}
	export module TreatmentCycle {
		export var POST: string = "TreatmentCycle.Post";
	}
	export module BatchPrint {
		export var CLINICAL_REPORTS_GET: string = "BatchPrint.ClinicalReports.Get";
	}
	export module Faxing {
		export var GET: string = "Faxing.Get";
	}
	export module TransportationAgency {
		export var PUT: string = "TransportationAgency.Put";
		export var GET: string = "TransportationAgency.Get";
		export var POST: string = "TransportationAgency.Post";
		export var DELETE: string = "TransportationAgency.Delete";
	}
	export module FeatureToggles {
		export var UseNHPaymentService: string = "billing-payment-service";
		export var BillingUseNewProcessClaim: string = "billing-use-new-process-claim";
		export var AtHomeWoundCareSuppliesRXHStandardForm: string = "athome-woundcare-supplies-RXH-standardized-form";
		export var BillingNewClaimsDashboard: string = "billing-new-claims-dashboard";
		export var BillingPatientStatementRefactor2: string = "billing-patient-statement-refactor-2";
		export var BillingPatientStatementForwardingBalance: string = "billing-patient-statement-forwarding-balance";
		export var BillingPatientStatementPatCalHide: string = "billing-patient-statement-patcal-hide";
		export var BillingPatientPaymentOldestToNewestClaims: string = "billing-patient-payment-oldest-to-newest-claims";
		export var NewClaimsDashboardForBillingReportingDb: string = "new-claims-dashboard-for-billing-reporting-db";
		export var BillingNewClaimsDashboardSPData: string = "billing-new-claims-dashboard-sp-data";
		export var BillingNewClaimsDashboardExportData: string = "billing-new-claims-dashboard-export-data";
		export var BillingNewClaimsDashboardKPIOptimization: string = "billing-new-claims-dashboard-kpi-optimization";
		export var BillingAccountBalanceWriteOff: string = "billing-account-balance-write-off";
		export var BillingPatientLookup: string = "billing-patient-lookup";
		export var BillingAutoAccidentWorkflow: string = "billing-autoaccident-workflow";
		export var BillingReloadPymtBatchesAfterClose: string = "billing-reload-pymt-batches-after-close";
		export var BillingEraRemitDetailsSproc: string = "billing-era-remit-details-sproc";
		export var NewVisitsForReview: string = "new-visits-for-review";
		export var ClaimsSSRSReports: string = "claims-ssrs-reports";
		export var ProviderSSRSReports: string = "provider-ssrs-reports";
		export var ClaimsByCreatedDateSSRSReport: string = "claims-by-created-date-ssrs-report";
		export var BillingPTHDefaultDateRange: string = "billing-pth-default-date-range";
		export var UpdateVisitUsingSignalR: string = "update-visit-status-using-signal-r";
		export var SchedulerPrintingEnhancements: string = "scheduler-printing-enhancements";
		export var EnableTissueAnalyticsWoundAnalysisEmbed: string = "enable-tissue-analytics-wound-analysis-embed";
		export var UseCloudUrlForVenProdOrderSend: string = "use-cloud-url-for-venprodorder";
		export var UseCloudUrlForVenProdCatalog: string = "use-cloud-url-for-venprodcatalog";
		export var MultipleTabsWarningModal: string = "multiple-tabs-warning-modal";
		export var ReturnToFormOnPatientParkingLot: string = "return-to-form-on-patient-parking-lot";
		export var StalledWoundNotification: string = "stalled-wound-notification";
		export var OIGAuthorshipEntryType: string = "oig-authorship-entry-type";
		export var RestorixOrderTemplate: string = "restorix-order-template";
		export var BillingPaymentBatchesModernization: string = "billing-payment-batches-modernization";
		export var CreateIndividualClaimForMultipleVisits: string = "create-individual-claim-for-multiple-visits";
		export var CTPeIVRMultipleSubmissions: string = "ctp-eivr-multiple-submissions";
		export var ApolloMedicalSupplyStandardizedForm: string = "apollo-medical-supply-standardized-form";
		export var PublishDocsToFHIR: string = "fhir-event";
		export var EnableFhirEHRSmartLaunches: string = "fhir-ehr-smart-launch";
		export var CHCStandardizedForm: string = "chc-burmans-standardized-form";
		export var ArgencisStandardizedForm: string = "argencis-standardized-form";
		export var MultipleClaimPaymentTab: string = "multiple-claim-payment-tab";
		export var DocumentViewerRewrite: string = "document-viewer-rewrite";
		export var BillingEditableDepositDate: string = "billing-editable-deposit-date";
		export var PrismStandardizedForm: string = "prism-medical-standardized-form";
		export var HealthcareProductsDeliveryStandardizedForm: string = "healthcare-products-delivery-standardized-form";
		export var HealthcareWarehouseStandardizedForm: string = "healthcare-warehouse-standardized-form";
		export var TWSRotechStandardizedForm: string = "tws-rotech-standardized-form";
		export var OverridePdfUrlsScheme: string = "override-pdf-urls-scheme";
		export var UseAzureImageSharpFunctions: string = "UseAzureImageSharpFunctions";
		export var PesDigitalIntake: string = "pes-digital-intake";
		export var PesPortal: string = "pes-portal";
		export var PesFacilityLocationVisitReminders: string = "pes-facility-location-visit-reminders";
		export var HomeCareDeliveredStandardizedForm: string = "home-care-delivered-standardized-form";
		export var DirectMedicalStandardizedForm: string = "direct-medical-standardized-form";
		export var AddHeaderToInterfacePdfs: string = "add-header-to-interface-pdfs";
		export var AddHeaderToBatchPrint: string = "add-header-to-batch-print";
		export var PowerBI: string = "PowerBI";
		export var CommunityMedicalStandardizedForm: string = "community-medical-standardized-form";
		export var AmericanWoundCareStandardizedForm: string = "american-wound-care-standardized-form";
		export var SoundHealthStandardizedForm: string = "sound-health-standardized-form";
		export var ByramHealthCareStandardizedForm: string = "byram-healthcare-standardized-form";
		export var LoadVisitsWithStoredProcedure: string = "load-visits-with-stored-procedure";
		export var SnfEmUpdate2024: string = "2024-snf-e-m-update";
		export var AdaptHealthPatientCareSolutionsStandardizedForm: string = "adapthealth-patient-care-solutions-standardized-form";
		export var FinalizeVisit: string = "finalize-visit-rewrite";
		export var BatchDischarge: string = "batch-discharge";
		export var BatchDischargeAdmissionTabToggle: string = "batch-discharge-admission-tab-toggle";
		export var POCNBIFileFormatEnabled: string = "poc-nbi-file-format-enabled";
		export var POCNBIFileFormat: string = "poc-nbi-file-format";
		export var NewLymphedemaDocument: string = "new_lymphedema_document";
		export var AutomateDisposableNPWT: string = "automate-disposable-NPWT-procedures";
		export var AzureEligibilityServiceUrl: string = "azure-eligibility-service-url";
		export var UseNewBillingClients: string = "use-new-billing-clients";
		export var AzureEligibilityApiUrl: string = "azure-eligibilityapi-url";
		export var AzureBillingApiUrl: string = "azure-billingapi-service-url";
		export var AzureDrFirstLacUrl: string = "azure-drfirst-lac-url";
		export var BillingMyReportsMigration: string = "billing-my-reports-migration";
		export var WoundQConnections: string = "wound-q-connections";
		export var AzureHl7ApiUrl: string = "azure-hl7api-url";
		export var ShowProcedureCodesOnSuperBill: string = "show-procedure-codes-on-superbill";
		export var EnableImageFuctionsApp: string = "enable-imagefunctions-app";
		export var BatchPrintSpinner: string = "batch-print-spinner";
		export var InsuranceScansAi: string = "insurance-scans-ai";
	}
	export module UserRoles {
		export var BILLING_ADMIN: string = "UserRoles.BillingAdmin";
		export var BILLING_ACCESS: string = "UserRoles.BillingAcess";
		export var BILLING_FRONT_DESK_USER: string = "UserRoles.BillingFrontDeskUser";
		export var PREVENT_DELETING_PATIENT_DOCUMENTATION: string = "UserRoles.PreventDeletingPatientDocumentation";
		export var BATCH_DISCHARGE: string = "UserRoles.BatchDischargeUser";
	}
}
	export module DataExport {
		export var GET: string = "DataExport.Get";
		export var PUT: string = "DataExport.Put";
		export var DELETE: string = "DataExport.Delete";
	}
}

export = Constants;